module.exports = __webpack_public_path__ + "img/img-3.14ae23f6.png";